<template>
  <div class="pin-code">
    <label
      v-for="n in Array(maxlength).fill('').keys()"
      :id="`pinCode-${n}`"
      :key="`pinCode-${n}`"
      :ref="`pinCode-${n}`"
      :for="`input-${n}`"
    >
      <input
        :id="`input-${n}`"
        :value="pin[n]"
        type="tel"
        class="pin-code__input"
        maxlength="2"
        pattern="\D*"
        @keyup.delete="onDelete(n)"
        @input="(e) => onInput(e, n)"
        @paste="onPaste"
        @keyup.left="focusPrevious(n)"
        @keyup.right="focusNext(n)"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: 'PinCode',
  props: {
    maxlength: {
      type: Number,
      default: 4
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    pin: {
      get() {
        return this.$options.filters.numbers(this.value, this.maxlength);
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  watch: {
    value(value) {
      if (value.length === this.maxlength) {
        this.$emit('completed', value);
      }

      this.pin = this.$options.filters.numbers(value, this.maxlength);
      this.focusLast();
    }
  },
  methods: {
    setPin(numbers) {
      this.pin = numbers;
    },
    onInput(event, index) {
      const { value } = event.target;
      const newPin = this.pin.split('');
      newPin[index] = value.replace(this.pin[index], '');
      this.pin = newPin.join('');
    },
    onDelete(index) {
      this.focusPrevious(index);
    },
    focusNext(number) {
      if (number < this.maxlength - 1) {
        this.$refs[`pinCode-${number + 1}`][0].focus();
      }
    },
    focusPrevious(number) {
      if (number > 0) {
        this.$refs[`pinCode-${number - 1}`][0].focus();
      }
    },
    focusLast() {
      const last = this.value.length > this.maxlength - 1 ? this.maxlength - 1 : this.value.length;
      this.$refs[`pinCode-${last}`][0].focus();
    },
    onPaste(e) {
      e.preventDefault();
      const numbers = e.clipboardData.getData('text/plain');
      this.pin = this.$options.filters.numbers(numbers);
    }
  }
};
</script>

<style lang="scss" scoped>
.pin-code{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  &__input{
    width: 2.75rem;
    background: $darkGray;
    margin: 0 .375rem;
    font-size: 1.5rem;
    text-align: center;
    outline: none;
    color: $lightGray;
    border-radius: .375rem;
    border: 3px solid transparent;
    &:focus{
      border-color: var(--teal-blue);
      box-shadow: 0 0 0 3px $lightGray;
      outline: 0;
    }

  }
}
</style>
